export const CheckIfNYCDOELicense = (licenseModel: string) => {
    if (licenseModel && licenseModel === "Unlimited use of catalog for unlimited users") {
        return true
    } else {
        return false
    }

}